export const app = {
  namespaced: true,
  
  state: {
    loading: false,
    sidebar: {
      collapsed: false,
      hovering: false,
      menuItems: [],
      mobileOpen: false
    },
    theme: 'light',
    settings: {
      notifications: true,
      language: 'en'
    }
  },
  
  getters: {
    isLoading: state => state.loading,
    sidebarCollapsed: state => state.sidebar.collapsed,
    sidebarHovering: state => state.sidebar.hovering,
    sidebarMenuItems: state => state.sidebar.menuItems,
    sidebarMobileOpen: state => state.sidebar.mobileOpen,
    currentTheme: state => state.theme,
    appSettings: state => state.settings
  },
  
  mutations: {
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    
    TOGGLE_SIDEBAR(state) {
      state.sidebar.collapsed = !state.sidebar.collapsed
    },
    
    SET_SIDEBAR_HOVERING(state, hovering) {
      state.sidebar.hovering = hovering
    },
    
    SET_SIDEBAR_MOBILE_OPEN(state, open) {
      state.sidebar.mobileOpen = open
    },
    
    TOGGLE_SIDEBAR_MOBILE(state) {
      state.sidebar.mobileOpen = !state.sidebar.mobileOpen
    },
    
    ADD_SIDEBAR_MENU_ITEM(state, item) {
      // Check if item already exists
      const existingIndex = state.sidebar.menuItems.findIndex(existing => existing.name === item.name)
      if (existingIndex === -1) {
        state.sidebar.menuItems.push(item)
        // Sort by order if provided, or by name
        state.sidebar.menuItems.sort((a, b) => {
          if (a.order !== undefined && b.order !== undefined) {
            return a.order - b.order
          }
          return a.name.localeCompare(b.name)
        })
      }
    },
    
    REMOVE_SIDEBAR_MENU_ITEM(state, itemName) {
      state.sidebar.menuItems = state.sidebar.menuItems.filter(item => item.name !== itemName)
    },
    
    SET_SIDEBAR_MENU_ITEMS(state, items) {
      state.sidebar.menuItems = items
    },
    
    SET_THEME(state, theme) {
      state.theme = theme
    },
    
    UPDATE_SETTINGS(state, settings) {
      state.settings = { ...state.settings, ...settings }
    }
  },
  
  actions: {
    setLoading({ commit }, loading) {
      commit('SET_LOADING', loading)
    },
    
    toggleSidebar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    
    setSidebarHovering({ commit }, hovering) {
      commit('SET_SIDEBAR_HOVERING', hovering)
    },
    
    setSidebarMobileOpen({ commit }, open) {
      commit('SET_SIDEBAR_MOBILE_OPEN', open)
    },
    
    toggleSidebarMobile({ commit }) {
      commit('TOGGLE_SIDEBAR_MOBILE')
    },
    
    addSidebarMenuItem({ commit }, item) {
      commit('ADD_SIDEBAR_MENU_ITEM', item)
    },
    
    removeSidebarMenuItem({ commit }, itemName) {
      commit('REMOVE_SIDEBAR_MENU_ITEM', itemName)
    },
    
    setSidebarMenuItems({ commit }, items) {
      commit('SET_SIDEBAR_MENU_ITEMS', items)
    },
    
    changeTheme({ commit }, theme) {
      commit('SET_THEME', theme)
      document.documentElement.setAttribute('data-theme', theme)
    },
    
    updateSettings({ commit }, settings) {
      commit('UPDATE_SETTINGS', settings)
    }
  }
} 